import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-correspondence-history',
  templateUrl: './correspondence-history.component.html',
  styleUrls: ['./correspondence-history.component.scss']
})
export class CorrespondenceHistoryComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
